export default __webpack_public_path__ + "static/media/nath_txt.a2760e23.png";